<template>
    <section class="excuse-table">
        <el-table
            :data="items"
            style="width: 100%"
            empty-text="No Excuses"
            @row-click="openExcuse">
            <el-table-column prop="date" label="Date">
                <template slot-scope="scope">{{ scope.row.date | moment("MM/DD/YYYY") }}</template>
            </el-table-column>
            <el-table-column prop="attendable_title" label="Course/Event" />
            <el-table-column prop="notes" label="Notes">
                <template slot-scope="scope">{{ scope.row.notes || '–' }}</template>
            </el-table-column>
            <slot name="actions"/>
        </el-table>
    </section>
</template>

<script>
export default {
    name: 'excuse-table',
    props: {
        items: {
            type: Array
        }
    },
    methods: {
        openExcuse(excuse) {
            this.$emit('row-click', excuse)
        }
    }
}
</script>

<style lang="stylus"></style>
